module.exports = __webpack_public_path__ + "img/BLOOD - Strength & Stability.2c14a582.png";